import { render, staticRenderFns } from "./ButtonIconComplexe.vue?vue&type=template&id=7cbeb382&scoped=true"
import script from "./ButtonIconComplexe.vue?vue&type=script&lang=ts"
export * from "./ButtonIconComplexe.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cbeb382",
  null
  
)

export default component.exports